import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

// default menus
import IconDashboard from '@/assets/menu/default/ic-dashboard.vue'
import IconSPKLU from '@/assets/menu/default/ic-spklu.vue'
import IconHomeCharging from '@/assets/menu/default/ic-homecharging.vue'
import IconMonitoring from '@/assets/menu/default/ic-monitoring.vue'
import IconUserManagement from '@/assets/menu/default/ic-usermanagement.vue'
import IconG20 from '@/assets/menu/default/ic-g20.vue'

// g20 menus
import IconG20Dashboard from '@/assets/menu/g20/ic-dashboard.vue'
import IconG20Monitoring from '@/assets/menu/g20/ic-monitoring.vue'
import IconG20Transaksi from '@/assets/menu/g20/ic-transaksi.vue'

// icon global
import IconBtnSpklu from '@/assets/icon/ic-spklu-text-white.vue'
import IconHouse from '@/assets/icon/ic-house.vue'
import IconCalendar from '@/assets/icon/ic-calendar.vue'
import IconFilter from '@/assets/icon/ic-filter.vue'
import IconExportExcel from '@/assets/icon/ic-export-excel.vue'

// icon maps
import IconSpkluBlue from '@/assets/maps/ic-spklu-blue.vue'
import IconSpkluGreen from '@/assets/maps/ic-spklu-green.vue'
import IconSpkluRed from '@/assets/maps/ic-spklu-red.vue'
import IconSpkluYellow from '@/assets/maps/ic-spklu-yellow.vue'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#2671D9',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      }
    }
  },
  icons: {
    values: {
      'ic-dashboard-new': {
        component: IconDashboard
      },
      'ic-monitoring-new': {
        component: IconMonitoring
      },
      'ic-spklu': {
        component: IconSPKLU
      },
      'ic-homecharging': {
        component: IconHomeCharging
      },
      'ic-usermanagement': {
        component: IconUserManagement
      },
      'ic-g20': {
        component: IconG20
      },
      'ic-dashboard': {
        component: IconG20Dashboard
      },
      'ic-monitoring': {
        component: IconG20Monitoring
      },
      'ic-transaksi': {
        component: IconG20Transaksi
      },
      'ic-spklu-text-white': {
        component: IconBtnSpklu
      },
      'ic-house': {
        component: IconHouse
      },
      'ic-calendar': {
        component: IconCalendar
      },
      'ic-filter': {
        component: IconFilter
      },
      'ic-export-excel': {
        component: IconExportExcel
      },
      'ic-spklu-blue': {
        component: IconSpkluBlue
      },
      'ic-spklu-green': {
        component: IconSpkluGreen
      },
      'ic-spklu-red': {
        component: IconSpkluRed
      },
      'ic-spklu-yellow': {
        component: IconSpkluYellow
      }
    }
  }
})
